/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */

/**
 * What the employee does with the vehicle of the day (FACF-117). Travels as an int on the
wire — never renumber.
 */
export type FacilityFlowCoreModulesPlanningEntitiesDriverRole = typeof FacilityFlowCoreModulesPlanningEntitiesDriverRole[keyof typeof FacilityFlowCoreModulesPlanningEntitiesDriverRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FacilityFlowCoreModulesPlanningEntitiesDriverRole = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
} as const;
